module.exports = __webpack_public_path__ + "e5de6e2f25275f6e08b4d0dd2d1408a2.png";